/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */

import { Handle } from 'rc-slider';
import React,{useState} from 'react'
import { useCallback } from 'react';
import { createUrl } from '../../redux/helper/CreateQuery';
import { removeLastComma } from '../../redux/helper/RemoveLastComma';
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";

export default function Filters({close,setFilter,Filter,handleFetch,setfilterUrl,setcurrentpage,filterOpen}) {
    const order_Status={
        'Pending Confirmation':1,
        'In Process':2,
        'Approved':3,
        'Out for Delivery':4,
        'Partially delivered':5,
        'Delieverd':6,
        'Completed':7,
        'Rejected':8   
    }
    const orderTypes = ['Trade', 'Trade EUB', 'Domestic', 'Free Service', 'Demo', 'Free Samples', 'Free Replacement', 'Service', 'Repair', 'Free Supplies'];
    const [selected, setselected] = useState('order_type');
    const getObjectUrl=()=>{
        let final='';
        Filter['order_status'].length>0 && Filter['order_status'].map((val)=>{
            final+=`${val},`
        })
        return removeLastComma(final);
        
        
    }
    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'order_type':
                if (Filter[key].length > 0) {
                    final += `&order_type=${createUrl(Filter[key])}`;
                }
                break;
            case 'order_status':
                if (Filter[key].length !== 0) {
                    final += `&status=${getObjectUrl()}`;
                }
                break;
            case 'payment_type':
                if (Filter[key].length !== 0) {
                    final += `&payment_type=${Filter[key]==='Advance Payment'?0:1}`;
                }
                break;
            default: break;
            }
        });
        setfilterUrl(final)
        handleFetch(final)
        return final;
    };
  

    const handleClear = ()=>{
        setFilter({
            order_type:[],
            order_status:[],
            payment_type:[]
        })
        setfilterUrl('')
        handleFetch('')

        
    }
    const HandleFilter=useCallback((key,val)=>{

        const Filtercopy={...Filter};
        const idx=Filtercopy[key].indexOf(val);
        if(idx=== -1){
            Filtercopy[key].push(val)
        }else{
            Filtercopy[key].splice(idx,1)
        }
        Filtercopy[key]
        setFilter(Filtercopy)
        return idx>-1
        // return false
    
    },[])
    return (
        <div className={`modal fade fixed top-0 left-0 ${filterOpen ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[470px] px-2.5" style={{margin:'auto'}}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button type="button"
                            onClick={()=>close(false)}
                            className="btn-close1 box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex active flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={()=>setselected('order_type')}>
                                    <a href="javascript:void(0)" className={`nav-link block text-base font-semibold ${selected==='order_type'?'active':''} text-[#AAA6AF] order relative w-full`}id="pills-priceranje" data-bs-toggle="pill" data-bs-target="#pills-pricetab" role="tab"
                                        aria-controls="pills-price" aria-selected="true">Order Type
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full my-4" role="presentation" onClick={()=>setselected('order_status')}>
                                    <a href="javascript:void(0)" className={`nav-link block text-base font-semibold ${selected==='order_status'?'active':''} text-[#AAA6AF] order relative w-full`} id="pills-size" data-bs-toggle="pill" data-bs-target="#pills-sizemm" role="tab"
                                        aria-controls="pills-sizemm" aria-selected="false" >Order Status
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={()=>setselected('payment_type')}>
                                    <a href="javascript:void(0)" className={`nav-link block text-base font-semibold ${selected==='payment_type'?'active':''} text-[#AAA6AF] order relative w-full`} id="pills-categories" data-bs-toggle="pill" data-bs-target="#pillcategorie" role="tab"
                                        aria-controls="pillcategorie" aria-selected="false">Payment Type
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[300px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane fade ${selected==='order_type'?'show active':''} px-3 fade overflow-auto h-[250px] sidebar`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            {orderTypes.map((order, orderIndex) => (
                                                <div className="flex items-center mb-3" key={`type-${orderIndex}`}>
                                                    <Checkbox
                                                        icon={
                                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes(order) ? '#555259' : ''}` }} />
                                                        }
                                                        name="my-input"
                                                        className="cursor-pointer"
                                                        checked={Filter.order_type?.includes(order)}
                                                        onChange={() => HandleFilter('order_type', order)}
                                                        borderColor={`${Filter.order_type?.includes(order) ? '#B8C5DC' : '#555259'}`}
                                                        style={{ cursor: 'pointer' }}
                                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                        id={order}
                                                    />
                                                    <label htmlFor={order} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">
                                                        {' '}
                                                        {order}
                                                    </label>
                                                </div>
                                            ))}                     
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${selected==='order_status'?'show active':''}`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                    <div className="ml-5 cursor-pointer">
                                        {Object.keys(order_Status).map((val,i)=>(
                                            <div key={i} className="relative flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filter['order_status']?.includes(order_Status[val]) ? '#555259':''}`}} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter['order_status'].includes(order_Status[val])}
                                                    onChange={()=>HandleFilter('order_status',order_Status[val])}    
                                                    borderColor={`${Filter['order_status'].includes(order_Status[val])?"#B8C5DC":"#555259"}`}
                                                    style={{ cursor: "pointer" }}
                                                    labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                                />
                                                <label 
                                                    onClick={()=>HandleFilter('order_status',order_Status[val])} 
                                                    htmlFor={`id-${i+1}`} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">{val}</label>
                                            </div>
                                        ))}
                                    
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${selected==='payment_type'?'show active px-3':'px-3 '}`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div className="cursor-pointer">
                                        <div className="relative flex items-center">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filter['payment_type']?.includes('Advance Payment') ? '#555259':''}`}} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                onChange={()=>HandleFilter('payment_type','Advance Payment')}
                                                checked={Filter['payment_type'].includes('Advance Payment')}
                                                borderColor={`${Filter['payment_type'].includes('Advance Payment')?"#B8C5DC":"#555259"}`}
                                                style={{ cursor: "pointer" }}
                                                labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                            />
                                            <label 
                                                onClick={()=>HandleFilter('payment_type','Advance Payment')}
                                                htmlFor="mn11" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Advance Payment</label>
                                        </div>
                                        <div className="relative  flex items-center mt-[14px]">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{background:`${Filter['payment_type']?.includes('On Credit') ? '#555259':''}`}} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                onChange={()=>HandleFilter('payment_type','On Credit')}
                                                checked={Filter['payment_type'].includes('On Credit')}
                                                borderColor={`${Filter['payment_type'].includes('On Credit')?"#B8C5DC":"#555259"}`}
                                                style={{ cursor: "pointer" }}
                                                labelStyle={{ marginLeft: 5, userSelect: "none" ,cursor:'pointer'}}
                                            />
                                            <label 
                                                onClick={()=>HandleFilter('payment_type','On Credit')}
                                                htmlFor="mn12" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">On Credit</label>
                                        </div>
                                    </div>
                                </div>
                            </div>   
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-5">
                                <button
                                    onClick={()=>handleClear()} type="button" className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]" data-bs-dismiss="modal" aria-label="Close">
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    onClick={()=>generateUrl()}
                                    type="button" className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
